import { render, staticRenderFns } from "./FUniswapWrapFTM.vue?vue&type=template&id=51d58a5c&"
import script from "./FUniswapWrapFTM.vue?vue&type=script&lang=js&"
export * from "./FUniswapWrapFTM.vue?vue&type=script&lang=js&"
import style0 from "./FUniswapWrapFTM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports